module.exports = __webpack_public_path__ + "img/2.812c87bb.png";